// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b00d4a87","513":"fdaef1c5","703":"df601ea1","787":"c10c65b6"}[chunkId] + ".chunk.js";
};